export default {
  borderRadius: '5px',
  spacing: 8
};



// WEBPACK FOOTER //
// ./styles/default-theme/layout.js